import DirectoryEditor from "./DirectoryEditor";

export default function Branches() {
  return (
    <DirectoryEditor
      resource="branches"
      title="Branches"
      eyebrow="Administration · Directory"
      description="Master list of branches / teams (e.g. EasyCAD, Internal Team, Marketing, Structural). Every employee is assigned to one branch. Renaming propagates to all employees automatically."
    />
  );
}
